/**
 * Implements a simple publish-subscribe event bus for decoupled communication between
 * different modules. It allows parts of the application, like the state manager, to broadcast events
 * (e.g. 'state changed', 'component selected') that other modules, like the property pane, can listen
 * and react to.
 */
namespace appn.designerv2.eventBus {
    export function publish(eventName: string, payload?: any): void {
        PubSub.publish(eventName, payload);
    }
    
    export function subscribe(eventName: string, callback: (payload: any) => void): PubSubJS.Token {
        return PubSub.subscribe(eventName, (_: any, data: any) => callback(data));
    }
    
    export function unsubscribe(token: PubSubJS.Token): void {
        PubSub.unsubscribe(token);
    }

    export function unsubscribeAll(event?: string): void {
        if (event)
            PubSub.unsubscribe(event);
        else
            PubSub.clearAllSubscriptions();
    }

    export function propertyUpdated(componentId: string, propName: string, propValue: any, oldValue: any, propPath?: string) {
        PubSub.publish(EVENTS.PROPERTY_UPDATED, { componentId, propName, propValue, oldValue, propPath });
    }

    export function subscribeToPropertyUpdates(callback: (payload: IPropertyUpdatedPayload) => void): PubSubJS.Token {
        return subscribe(EVENTS.PROPERTY_UPDATED, callback);
    }
}
